// extracted by mini-css-extract-plugin
module.exports = {"company-performance-fallback":"CompanyPerformanceFallback_company-performance-fallback__1vrb1"};